import axios from "axios";
import { apiClient } from "../../api/services/api.service";

const API_URL = process.env.REACT_APP_API_URL + '/decisions';

const JSON_HEADERS = { "Content-Type": "application/json" };

// Login — no auth required
export const login = async (payload: { email: string; password: string }) =>
    await axios.post(`${API_URL}/api-token-auth/`, payload, {
        headers: JSON_HEADERS,
    })

// Refresh token — no auth required
export const refreshToken = async (refresh: string) =>
    await axios.post(`${API_URL}/api-token-refresh/`, { refresh }, {
        headers: JSON_HEADERS,
    })

// Verify token — no auth required
export const verifyToken = async (token: string) =>
    await axios.post(`${API_URL}/api-token-verify/`, { token }, {
        headers: JSON_HEADERS,
    })

// Logout — blacklist refresh token (requires auth)
export const logout = async (refresh: string) =>
    await apiClient.post('/auth/logout/', { refresh })

// Get current user profile — requires auth
export const getProfile = async () =>
    await apiClient.get('/users/me/')

// Update own profile
export const updateProfile = async (payload: any) =>
    await apiClient.patch('/users/me/', payload)

// Change own password
export const changePassword = async (payload: { old_password: string; new_password: string }) =>
    await apiClient.patch('/users/me/change-password/', payload)
